function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import projectContractorsService from '@rd-web-markets/de/dist/services/project_contractor.service';
import { Row, Button, Badge, Form, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import ProjectContractorForm from '@rd-web-markets/de/dist/technicalProof/creating_application/ProjectContractorForm';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util/';
import yearFinancialDetailsService from '../../services/year_financial_details.service';
import { useTranslation } from 'react-i18next';
import financialDetailsDocumentsService from '../../services/financial_details_documents.service';
import { SELECTED_ROW_DIMMED_CLASS } from '../../constants';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import { DeleteButtonSquare } from '@rd-web-markets/shared/dist/util/buttons';
const currencyFormatter = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2
});
const ContractResearchSection = _ref => {
  var _report$project_elste, _report$project_elste2;
  let {
    report,
    contractType = 'bfsz',
    projectElsterDetailId = null,
    updateProjectElsterDetail,
    isVersion8
  } = _ref;
  const [contractors, setContractors] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const fetchData = async () => {
      const contractors = await projectContractorsService.all(report.id, contractType, projectElsterDetailId);
      setContractors(contractors);
    };
    fetchData();
  }, [report.id, projectElsterDetailId, contractType]);
  const deleteProjectContractor = async contractor => {
    if (window.confirm(t("".concat(window.MARKET_CONSTANTS.DELETE_CONFIRMATION_MESSAGE)))) {
      await projectContractorsService.delete(report.id, contractor.id);
      setContractors([...contractors.filter(c => c.id !== contractor.id)]);
      setSelectedContractor(null);
    }
  };
  const createProjectContractor = () => {
    setSelectedContractor({});
  };
  const closeForm = () => {
    setSelectedContractor(null);
  };
  const handleChange = e => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setSelectedContractor(_objectSpread(_objectSpread({}, selectedContractor), {}, {
      [e.target.name]: value
    }));
  };
  const editProjectContractor = (e, contractor) => {
    var _contractor$cost_calc;
    e.preventDefault();
    setSelectedYear(String(contractor === null || contractor === void 0 || (_contractor$cost_calc = contractor.cost_calculations) === null || _contractor$cost_calc === void 0 || (_contractor$cost_calc = _contractor$cost_calc.total_per_year[0]) === null || _contractor$cost_calc === void 0 ? void 0 : _contractor$cost_calc.year));
    setSelectedContractor(contractor);
  };
  const handleAsyncChange = (e, index) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const updatedContractors = [...contractors];
    updatedContractors[index][e.target.name] = value;
    setContractors(updatedContractors);
  };
  const handleAsyncSubmit = async index => {
    const updatedContractor = await projectContractorsService.update(report.id, contractors[index]);
    const newContractors = [...contractors];
    newContractors[index] = updatedContractor;
    setContractors(newContractors);
  };
  const handleSubmit = async () => {
    if (Object.keys(selectedContractor).length !== 0) {
      setLoading(true);
      try {
        if (!selectedContractor.id) {
          const newContractor = await projectContractorsService.create(report.id, _objectSpread(_objectSpread({}, selectedContractor), {}, {
            contractor_type: contractType,
            project_elster_detail_id: projectElsterDetailId
          }));
          setContractors([...contractors, newContractor]);
          setSelectedContractor(_objectSpread({}, newContractor));
        } else {
          const updatedContractor = await projectContractorsService.update(report.id, selectedContractor);
          const newContractors = contractors;
          const index = newContractors.findIndex(c => {
            return c.id === updatedContractor.id;
          });
          newContractors[index] = updatedContractor;
          setContractors(newContractors);
        }
      } catch (e) {
        dispatch(handleError(e));
      } finally {
        setLoading(false);
      }
    }
  };
  const handleFinancialDetailChange = async (e, id) => {
    const financialDetails = selectedContractor.financial_details;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    financialDetails.find(detail => detail.id === id)[e.target.name] = value;
    setSelectedContractor(_objectSpread(_objectSpread({}, selectedContractor), {}, {
      financial_details: financialDetails
    }));
  };
  const saveFinancialDetailChange = async financialDetail => {
    try {
      const response = await yearFinancialDetailsService.update(selectedContractor.id, financialDetail);
      return response;
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const addFile = async (detail, e) => {
    let fd = new FormData();
    fd.append('file', e);
    setLoading(true);
    try {
      await yearFinancialDetailsService.upload(detail, fd);
      const updatedProjectContractor = await projectContractorsService.get(report.id, selectedContractor.id);
      setSelectedContractor(updatedProjectContractor);
    } catch (error) {
      dispatch(handleError(error));
    } finally {
      setLoading(false);
    }
  };
  const removeAttachment = async (detail, attachmentId, filename) => {
    if (!window.confirm(t("".concat(window.MARKET_CONSTANTS.DELETE_FILE_CONFIRMATION_MESSAGE)) + ": ".concat(filename))) return;
    setLoading(true);
    try {
      await financialDetailsDocumentsService.delete(detail.id, attachmentId);
      const updatedProjectContractor = await projectContractorsService.get(report.id, selectedContractor.id);
      setSelectedContractor(updatedProjectContractor);
    } catch (error) {
      dispatch(handleError(error));
    } finally {
      setLoading(false);
    }
  };
  const handleCreateDetail = async cost_type => {
    const financial_detail = {
      cost_type: cost_type
    };
    try {
      setLoading(true);
      const createdDetail = await yearFinancialDetailsService.create(selectedContractor.id, financial_detail);
      const financialDetails = selectedContractor.financial_details;
      financialDetails.push(createdDetail);
      setSelectedContractor(_objectSpread(_objectSpread({}, selectedContractor), {}, {
        financial_details: financialDetails,
        cost_calculations: createdDetail.cost_calculations
      }));
    } catch (err) {
      dispatch(handleError(err));
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteDetail = async id => {
    if (window.confirm(t("".concat(window.MARKET_CONSTANTS.DELETE_CONFIRMATION_MESSAGE)))) {
      try {
        setLoading(true);
        await yearFinancialDetailsService.delete(selectedContractor.id, id);
        const contractorNewData = await projectContractorsService.get(report.id, selectedContractor.id);
        setSelectedContractor(_objectSpread({}, contractorNewData));
      } catch (err) {
        dispatch(handleError(err));
      } finally {
        setLoading(false);
      }
    }
  };
  const renderStatus = isCompleted => {
    if (isCompleted) {
      return /*#__PURE__*/React.createElement(Badge, {
        pill: true,
        bg: "success"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-white"
      }, "done"));
    } else {
      return /*#__PURE__*/React.createElement(Badge, {
        pill: true,
        bg: "danger"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-white"
      }, "close"));
    }
  };
  const handleSetSelectedContractor = selectedContractor => {
    const index = contractors.findIndex(c => c.id === selectedContractor.id);
    contractors[index] = selectedContractor;
    setSelectedContractor(selectedContractor);
    setContractors([...contractors]);
  };
  const saveFinancialYearChange = () => {};
  if (!contractors) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-between pb-3"
  }, projectElsterDetailId && /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Dropdown, {
    name: "type_of_research",
    label: "type_of_research",
    value: (_report$project_elste = report === null || report === void 0 || (_report$project_elste2 = report.project_elster_detail) === null || _report$project_elste2 === void 0 ? void 0 : _report$project_elste2.type_of_research) !== null && _report$project_elste !== void 0 ? _report$project_elste : '',
    options: [{
      key: 'tor_not_selected',
      value: 'not_selected',
      text: ''
    }, {
      key: 'tor_in_house_research',
      value: 'in_house_research',
      text: 'in_house_research'
    }, {
      key: 'tor_research_partially_contracted_out',
      value: 'research_partially_contracted_out',
      text: 'research_partially_contracted_out'
    }, {
      key: 'tor_research_completely_contracted_out',
      value: 'research_completely_contracted_out',
      text: 'research_completely_contracted_out'
    }],
    dataTestId: "type_of_research_dropdown",
    onChange: val => {
      updateProjectElsterDetail(_objectSpread(_objectSpread({}, report.project_elster_detail), {}, {
        type_of_research: val
      }));
    },
    labelColSpan: 3,
    labelStyle: {
      textAlign: 'end'
    },
    showNullOption: false,
    componentStyle: {
      width: '600px'
    },
    dropdownStyle: {
      width: '400px'
    }
  })), !selectedContractor && /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 4,
      offset: projectElsterDetailId ? 4 : 8
    },
    className: "d-flex justify-content-end align-items-start"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => createProjectContractor({}),
    variant: "primary",
    disabled: report.application_submitted && contractType === 'bfsz',
    className: "mx-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add_new_contractor')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("table", {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("th", null, t('contractor_name')), /*#__PURE__*/React.createElement("th", null, t('status')), /*#__PURE__*/React.createElement("th", null, t('rd_work_objectives')), /*#__PURE__*/React.createElement("th", null, t('order_amount_in_euros')), /*#__PURE__*/React.createElement("th", null, t('open_detailed')), /*#__PURE__*/React.createElement("th", null, t('delete')))), /*#__PURE__*/React.createElement("tbody", {
    className: "text-center"
  }, contractors.map((contractor, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: contractor.id,
      className: contractor.id === (selectedContractor === null || selectedContractor === void 0 ? void 0 : selectedContractor.id) ? SELECTED_ROW_DIMMED_CLASS : ''
    }, /*#__PURE__*/React.createElement("td", null, contractor.research_institute_name), /*#__PURE__*/React.createElement("td", null, renderStatus(contractor.is_completed)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
      as: Form.Control,
      onChange: e => handleAsyncChange(e, index),
      onBlur: () => handleAsyncSubmit(index),
      object: contractor,
      name: "rnd_work_objectives",
      controlAs: "textarea",
      disabled: report.application_submitted,
      rows: "5"
    })), /*#__PURE__*/React.createElement("td", {
      className: "text-center"
    }, currencyFormatter.format(contractor.cost_calculations.total_of_all_years)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => editProjectContractor(e, contractor)
    }, t('to_contractor_details'))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(DeleteButtonSquare, {
      onClick: () => deleteProjectContractor(contractor),
      disabled: report.application_submitted
    })));
  })))), selectedContractor && /*#__PURE__*/React.createElement(ProjectContractorForm, {
    projectElsterDetailId: projectElsterDetailId,
    isVersion8: isVersion8,
    applicationSubmitted: report.application_submitted,
    addFile: addFile,
    removeAttachment: removeAttachment,
    handleCreateDetail: handleCreateDetail,
    handleChange: handleChange,
    contractor: selectedContractor,
    closeForm: closeForm,
    saveFinancialYearChange: saveFinancialYearChange,
    handleSubmit: handleSubmit,
    loading: loading,
    handleDeleteDetail: handleDeleteDetail,
    handleFinancialDetailChange: handleFinancialDetailChange,
    saveFinancialDetailChange: saveFinancialDetailChange,
    setSelectedContractor: handleSetSelectedContractor,
    selectedYear: selectedYear,
    setSelectedYear: setSelectedYear
  }));
};
export default ContractResearchSection;